import type { TOC } from '@ember/component/template-only';
import { PrismIcon, PrismTooltipHeader } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';

interface HotelStrategyTooltipsTooltipChartDetailViewSignature {
  Args: {
    dataForTooltip: unknown;
    ratesColumnHeaderTranslation: unknown;
    tooltipLabel: unknown;
  };
}

const HotelStrategyTooltipsTooltipChartDetailView = <template>
  {{! @glint-nocheck: not typesafe yet }}
  <div
    class="default-tooltip default-tooltip--no-max-width default-table-tooltip"
  >
    <PrismTooltipHeader>
      {{@tooltipLabel}}
    </PrismTooltipHeader>
    <table class="default-table">
      <tbody>
        <tr>
          <td class="text-200--bold">
            {{t "general.hotel.plural" count=1}}
          </td>
          <td class="text-200--bold">
            {{@ratesColumnHeaderTranslation}}
          </td>
          <td></td>
          <td class="text-200--bold">
            {{t "general.room_name"}}
          </td>
        </tr>
        {{#each @dataForTooltip as |rowData|}}
          <tr class={{if rowData.isOwnHotel "highlight"}}>
            <td>
              <div class="rate-strategy-tooltip-cell-width-limit truncate">
                <div
                  class="identifier-bullet"
                  style={{rowData.backgroundColor}}
                ></div>
                {{rowData.name}}
              </div>
            </td>
            <td>{{rowData.formattedRate}}</td>
            <td>
              <div class="flex flex-row">
                {{#each rowData.rateTypeIcons as |icon|}}
                  {{#if icon}}
                    <PrismIcon @name={{icon}} @size="extra-small" />
                  {{/if}}
                {{/each}}
              </div>
            </td>
            <td>
              <div class="rate-strategy-tooltip-cell-width-limit truncate">
                {{rowData.roomname}}
              </div>
            </td>
          </tr>
        {{/each}}
      </tbody>
    </table>
  </div>
</template> satisfies TOC<HotelStrategyTooltipsTooltipChartDetailViewSignature>;

export default HotelStrategyTooltipsTooltipChartDetailView;
